<template>
	<div class="storage-error-wrapper">
		<div class="storage-error">
			<ExclaimBackgroundIcon class="error-icon" />
			<div>{{ $t('cookie_error_title') }}</div>
			<div>
				{{ $t('cookie_error_description') }}
			</div>
			<Button
				link
				href="https://support.pronto.io/en/articles/4299051-enabling-third-party-cookies-on-web-browsers"
				newTab
			>
				{{ $t('cookie_error_link') }}
			</Button>
		</div>
	</div>
</template>

<script>
import { Button } from '@/components/common'
import { ExclaimBackgroundIcon } from '@/icons'

export default {
	components: { Button, ExclaimBackgroundIcon },
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.storage-error-wrapper {
	background-color: #d1d2d4;
	height: 100vh;
	width: 100vw;
	padding: 25px;

	.storage-error {
		padding: 53px;
		@include flex-column-center;
		justify-content: center;
		font-size: 20px;
		border-radius: 8px;
		height: 100%;
		width: 100%;
		background-color: #ffffff;
		text-align: center;

		div:nth-of-type(1) {
			margin-top: 50px;
			margin-bottom: 25px;
		}

		div:nth-of-type(2) {
			font-size: 17px;
		}

		a {
			margin-top: 10px;
		}

		.error-icon {
			text-align: center;
		}
	}
}
</style>
